import React, { useState, useEffect } from 'react';
import { Button, Dialog, DialogContent, DialogActions, DialogTitle, TextField, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TablePagination, InputAdornment, IconButton, Select, MenuItem,Alert,InputLabel, FormControl } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useDispatch, useSelector } from 'react-redux';
import { CargarUsers, updateUsers,updateRolUsers,AddUsers } from "../../store/user.actions";
import { ROLES, userService } from '../../services/user.service';
import PersonIcon from '@mui/icons-material/Person';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ImageIcon from '@mui/icons-material/Image';
import WorkIcon from '@mui/icons-material/Work';
import EmailIcon from '@mui/icons-material/Email';
import LockIcon from '@mui/icons-material/Lock';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import { BsSliders } from "react-icons/bs";
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import EngineeringIcon from '@mui/icons-material/Engineering';
import GavelIcon from '@mui/icons-material/Gavel';
import PeopleIcon from '@mui/icons-material/People';


const UserManagement = ({ open, onClose, selectRegion }) => {
  const members = useSelector(storeState => storeState.userModule.users);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [editingUser, setEditingUser] = useState(null);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [createDialogOpen, setCreateDialogOpen] = useState(false);
  const [newUser, setNewUser] = useState({ imgurl: '', nombre: '', unidad: '', correo: '', apellido: '', password_hash: '', rol: '',  region: '' });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const DataInfo = useSelector(storeState => storeState.infoModulo.infoM); // Obtener los datos de la base de datos
  const regionOptions = DataInfo?.regionOptions || []; // Extraer regionOptions de DataInfo

  const roles = ['Administracion', 'Unidades Tecnicas', 'Auditor'];

  const user = userService.getLoggedinUser().data.data; // Usuario logueado en la interfaz
  const isEditable = user.rol === ROLES.ADMIN; // Solo administrador puede editar
  const [error, setError] = useState('');
  // Estado para manejar la alerta
  const [alert, setAlert] = useState(null);
  const [alertMessage, setAlertMessage] = useState('');


  useEffect(() => {
    if (!members || members.length === 0) {

      console.log("Me estoy cargando de nuevo ");
      CargarUsers(selectRegion);
    } else {
      setFilteredUsers(
        members.filter(user => user.nombre.toLowerCase().includes(searchTerm.toLowerCase()))
      );
    }
  }, [members, searchTerm]);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // const handleEditClick = (user) => {
  //   setEditingUser({ ...user, rol: user.rol });
  //   setEditDialogOpen(true);

  // };

  // const regionOptions = [
  //   { id_region: 1, nombre_region: 'REGION LEMPA' },
  //   { id_region: 2, nombre_region: 'REGION VALLE DE SULA' },
  //   { id_region: 3, nombre_region: 'LEMPA NACIONAL' }
  // ];
  
  const handleEditClick = (user) => {
    setEditingUser({ 
        ...user,
        estado: user.estado,
        created_at: user.created_at,
        updated_at: user.updated_at, 
        rol: user.rol, 
        responsable: user.responsable || [] // Asegúrate de que 'responsable' esté definido, usa un arreglo vacío si no lo está
    });
    setEditDialogOpen(true);
};

  const handleSave = async () => {
    try {
      const updatedUser = {
        id_usuario: editingUser.id_usuario,
        nombre: editingUser.nombre,
        apellido: editingUser.apellido,
        unidad: editingUser.unidad,
        imgurl: editingUser.imgurl,
        correo: editingUser.correo,
        password_hash: editingUser.password_hash,
        fk_region_id: editingUser.fk_region_id,
        estado: editingUser.estado,
        created_at: editingUser.created_at,
        updated_at:editingUser.updated_at,
        responsable: editingUser.responsable, // Incluye el arreglo de responsables
        rol: editingUser.rol
      };
      
      await updateUsers(updatedUser);
    setFilteredUsers(filteredUsers.map(user => (user.id_usuario === editingUser.id_usuario ? editingUser : user)));
    setAlertMessage('Usuario actualizado con éxito.');
    setEditDialogOpen(false);
    setEditingUser(null);
  } catch (error) {
    console.error('Error al guardar los datos del usuario:', error);
    setAlertMessage('Error al actualizar el usuario. Por favor, inténtelo de nuevo.');
  }
  };

  const handleSaveUser = () => {
    if (
      !newUser.nombre ||
      !newUser.apellido ||
      !newUser.imgurl ||
      !newUser.unidad ||
      !newUser.correo ||
      !newUser.region ||
      !newUser.password_hash
    ) {
      setAlert({ type: 'error', message: 'Por favor complete todos los campos.' });
      return;
    }
  
    // Si todos los campos están completos, limpiar el error y continuar con la lógica de guardado
    setAlert(null); // Limpiar cualquier alerta anterior
    handleAddUser(newUser);
  };





  const handleRoleChange = async (event, user) => {
    const newRole = event.target.value;
    try {
      const updatedUser = { ...user, rol: newRole };
      const RolUser = {
        rol: newRole,
        fk_usuario_id: updatedUser.id_usuario,
        estado: 0,
       };


      await updateRolUsers(updatedUser,RolUser);
      setFilteredUsers(filteredUsers.map(u => (u.id_usuario === user.id_usuario ? updatedUser : u)));
      setAlertMessage('Rol actualizado Correctamente.');
    } catch (error) {
      console.error('Error al guardar el rol del usuario:', error);
      setAlertMessage('Error al actualizar el Rol');
      
    }
  };


  const handleAddUser = async () => {
    try {
      // Crear el objeto del nuevo usuario con los datos necesarios
      const addUser = {
        nombre: newUser.nombre,
        apellido: newUser.apellido,
        unidad: newUser.unidad,
        imgurl: newUser.imgurl,
        password_hash: newUser.password_hash,
        correo: newUser.correo,
        fk_region_id: newUser.region,
        estado: '1',
      };
  
      const newUserFromApi = await AddUsers(addUser);
  
      // Verificar si el usuario fue creado correctamente
      if (newUserFromApi && newUserFromApi.id_usuario) {
        const updatedMembers = [newUserFromApi, ...members];
        setFilteredUsers(updatedMembers);
        setNewUser({ imgurl: '', nombre: '', unidad: '', correo: '', apellido: '', password_hash: '', rol: '', region:'' });
        setAlert({ type: 'success', message: 'Usuario guardado con éxito.' });
        // setCreateDialogOpen(false);
      } else {
        setAlert({ type: 'error', message: 'Error en la creación del usuario.' });
      }
    } catch (error) {
      setAlert({ type: 'error', message: 'Error en la creación del usuario.' });
    }
  };
  
 

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center' }}>
  <PeopleIcon sx={{ marginRight: 2 }} />
  GESTIÓN DE USUARIOS
</DialogTitle>
    
      <DialogContent >
        <TextField
          label="Buscar Usuarios"
          fullWidth
          margin="normal"
          variant="outlined"
          value={searchTerm}
          onChange={handleSearchChange}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton edge="end">
                  <SearchIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        {isEditable && (
          <Button variant="contained" color="primary" onClick={() => setCreateDialogOpen(true)}>
            Crear Nuevo Usuario
          </Button>
          
        )}

        {/* alerta de actualizado */}
           {alertMessage && (
  <Alert 
    severity={alertMessage.includes('Error') ? 'error' : 'success'}
    sx={{ textAlign: 'center', justifyContent: 'center', alignItems: 'center',marginBottom: '-10px',marginTop: '-5px' }}
  >
    {alertMessage}
  </Alert>
)}

        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
              <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>Imagen</TableCell>
              <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>Nombre</TableCell>
              <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>Unidad</TableCell>
              <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>Correo</TableCell>
              <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>Rol</TableCell>
              <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>Acciones</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredUsers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(user => (
                <TableRow key={user.id_usuario}>
                  <TableCell align="center">
                    <img src={user.imgurl || 'https://via.placeholder.com/50'} alt={user.nombre} style={{ width: 50, height: 50, borderRadius: '50%' }} />
                  </TableCell>
                  <TableCell>{user.nombre}</TableCell>
                  <TableCell>{user.unidad}</TableCell>
                  <TableCell>{user.correo}</TableCell>
                  <TableCell align="center">
                  <Select
                    value={user.rol || ''}
                    onChange={(e) => handleRoleChange(e, user)}
                    autoWidth
                    variant="outlined"
                    style={{ width: '160px' }}
                    disabled={!isEditable}
                  >
                    {roles.map((rol, index) => (
                      <MenuItem key={index} value={rol}>
                        {rol}
                      </MenuItem>
                    ))}
                  </Select>
                </TableCell>
                  <TableCell align="center">
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={() => handleEditClick(user)}
                      disabled={!isEditable}
                    >
                      Editar
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={filteredUsers.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </DialogContent>

      <Dialog open={editDialogOpen} onClose={() => setEditDialogOpen(false)}>
      <DialogTitle sx={{ backgroundColor: '#2682b3', color: '#fff', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 2, marginBottom:'5px'}}>
        <BsSliders style={{ marginRight: 10, fontSize: '1.5rem' }} />
        EDITAR USUARIO
      </DialogTitle>
      {alertMessage && (
  <Alert 
    severity={alertMessage.includes('Error') ? 'error' : 'success'}
    sx={{ textAlign: 'center', justifyContent: 'center', alignItems: 'center',marginBottom: '-10px' }}
  >
    {alertMessage}
  </Alert>
)}

        <DialogContent>
          <TextField
            margin="dense"
            label="Nombre"
            fullWidth
            variant="outlined"
            value={editingUser?.nombre || ''}
            onChange={(e) => setEditingUser({ ...editingUser, nombre: e.target.value })}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                 <AccountCircleIcon />
                </InputAdornment>
              ),
            }}
          />
          <TextField
            margin="dense"
            label="Apellido"
            fullWidth
            variant="outlined"
            value={editingUser?.apellido || ''}
            onChange={(e) => setEditingUser({ ...editingUser, apellido: e.target.value })}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <AccountCircleIcon />
                </InputAdornment>
              ),
            }}
          />
          <TextField
            margin="dense"
            label="URL de Imagen"
            fullWidth
            variant="outlined"
            value={editingUser?.imgurl || ''}
            onChange={(e) => setEditingUser({ ...editingUser, imgurl: e.target.value })}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <ImageIcon />
                </InputAdornment>
              ),
            }}
          />
          <TextField
            margin="dense"
            label="Unidad"
            fullWidth
            variant="outlined"
            value={editingUser?.unidad || ''}
            onChange={(e) => setEditingUser({ ...editingUser, unidad: e.target.value })}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <WorkIcon />
                </InputAdornment>
              ),
            }}
          />
          <TextField
            margin="dense"
            label="Correo"
            fullWidth
            variant="outlined"
            value={editingUser?.correo || ''}
            onChange={(e) => setEditingUser({ ...editingUser, correo: e.target.value })}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <EmailIcon />
                </InputAdornment>
              ),
            }}
          />
          <TextField
                margin="dense"
                label="Contraseña"
                type="password"
                fullWidth
                variant="outlined"
                value={editingUser?.password_hash || ''}
                onChange={(e) => setEditingUser({ ...editingUser, password_hash: e.target.value })}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <LockIcon />
                    </InputAdornment>
                  ),
                }}
              />

               {/* Nuevo Select para la región */}
    <FormControl fullWidth margin="dense">
      <InputLabel id="region-select-label">Región</InputLabel>
      <Select
        labelId="region-select-label"
        value={editingUser?.fk_region_id || ''}  
        onChange={(e) => setEditingUser({ ...editingUser, fk_region_id: e.target.value })} 
        label="Región"
      >
        {regionOptions.map((region) => (
          <MenuItem key={region.id_regioncde} value={region.id_regioncde}>
            {region.nombre_region}
          </MenuItem>
        ))}
      </Select>
    </FormControl>



        </DialogContent>
        <DialogActions
        sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
      >
          {/* <Button onClick={() => setEditDialogOpen(false)} color="inherit"  startIcon={<CancelIcon />}>
            Cancelar
          </Button> */}
          <Button
      onClick={handleSave}
      startIcon={<SaveIcon />}
      sx={{
        backgroundColor: '#2596be',
        color: 'white',
        '&:hover': {
          backgroundColor: '#3daad1',
        },
        padding: '10px 20px',
        borderRadius: '8px',
        fontWeight: 'bold',
        boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.2)',
        textTransform: 'none',
      }}
    >
      Actualizar
    </Button>
        </DialogActions>
      </Dialog>


      <Dialog open={createDialogOpen} onClose={() => setCreateDialogOpen(false)}>
    <DialogTitle sx={{ backgroundColor: '#2682b3', color: '#fff', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 2, marginBottom: '5px' }}>
      <BsSliders style={{ marginRight: 10, fontSize: '1.5rem' }} />
      CREAR NUEVO USUARIO
    </DialogTitle>
    
    {alert && (
      <Alert 
        severity={alert.type} 
        sx={{ 
          textAlign: 'center', 
          justifyContent: 'center', 
          alignItems: 'center',
          margin: '10px auto', 
          maxWidth: '350px', 
          fontSize: '0.875rem',
          marginBottom: '-10px'
        }}
      >
        {alert.message}
      </Alert>
    )}
    <DialogContent>
      <TextField
        required
        margin="dense"
        label="Nombre"
        fullWidth
        variant="outlined"
        value={newUser.nombre}
        onChange={(e) => setNewUser({ ...newUser, nombre: e.target.value })}
        InputProps={{
          startAdornment: 
          <InputAdornment position="start">
            <AccountCircleIcon  />
          </InputAdornment>
        }}
      />
      <TextField
        required
        margin="dense"
        label="Apellido"
        fullWidth
        variant="outlined"
        value={newUser.apellido}
        onChange={(e) => setNewUser({ ...newUser, apellido: e.target.value })}

        InputProps={{
          startAdornment: 
          <InputAdornment position="start">
            <AccountCircleIcon  />
          </InputAdornment>
        }}
      />
      <TextField
        required
        margin="dense"
        label="URL de Imagen"
        fullWidth
        variant="outlined"
        value={newUser.imgurl}
        onChange={(e) => setNewUser({ ...newUser, imgurl: e.target.value })}
        InputProps={{
          startAdornment: 
          <InputAdornment position="start">
           <ImageIcon  />
          </InputAdornment>
        }}

      />
      <TextField
        required
        margin="dense"
        label="Unidad"
        fullWidth
        variant="outlined"
        value={newUser.unidad}
        onChange={(e) => setNewUser({ ...newUser, unidad: e.target.value })}
        InputProps={{
          startAdornment: 
          <InputAdornment position="start">
           <WorkIcon />
          </InputAdornment>
        }}
      />
      <TextField
        required
        margin="dense"
        label="Correo"
        fullWidth
        variant="outlined"
        value={newUser.correo}
        onChange={(e) => setNewUser({ ...newUser, correo: e.target.value })}
        InputProps={{
          startAdornment: 
          <InputAdornment position="start">
           <EmailIcon  />
          </InputAdornment>
        }}
      />
      <TextField
        required
        margin="dense"
        label="Contraseña"
        type="password"
        fullWidth
        variant="outlined"
        value={newUser.password_hash}
        onChange={(e) => setNewUser({ ...newUser, password_hash: e.target.value })}
        InputProps={{
          startAdornment: 
          <InputAdornment position="start">
          <LockIcon />
          </InputAdornment>
        }}
      />



 {/* Select para la región */}
      <FormControl fullWidth margin="dense">
        <InputLabel id="region-select-label">Región</InputLabel>
        <Select
          labelId="region-select-label"
          value={newUser.region}  // Guardará el id_region
          onChange={(e) => setNewUser({ ...newUser, region: e.target.value })}
          label="Región"
        >
          {regionOptions.map((region) => (
            <MenuItem key={region.id_regioncde} value={region.id_regioncde}>
              {region.nombre_region}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

    </DialogContent>

    <DialogActions sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <Button
        onClick={handleSaveUser}
        startIcon={<SaveIcon />}
        sx={{
          backgroundColor: '#2596be',
          color: 'white',
          '&:hover': {
            backgroundColor: '#3daad1',
          },
          padding: '10px 20px',
          borderRadius: '8px',
          fontWeight: 'bold',
          boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.2)',
          textTransform: 'none',
          marginTop: '-10px'
        }}
      >
        Guardar
      </Button>
    </DialogActions>
  </Dialog>
    </Dialog>
  );
};

export default UserManagement;
